var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:{ 'receiving-skeleton-text b-skeleton-animate-fade': _vm.props.loading },attrs:{"aria-hidden":_vm.props.loading ? 'true' : null}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }